export const CHARGE_POINT_REFRESH_TIMEOUT = 10000

export const CHARGEPOINT_MIN_CURRENT = 6

export const capiPhaseModeOptions = ['1P', '3P'].map((x) => ({ value: x, label: x }))
export const capiPhaseOptions = ['L1', 'L2', 'L3'].map((x) => ({ value: x, label: x }))
export const installationPhasesOptionsTN = ['1', '3'].map((x) => ({ value: x, label: x }))
export const installationPhasesOptionsIT = ['2', '3'].map((x) => ({ value: x, label: x }))
export const installationPhasesOrderOptions = ['RST', 'RTS', 'SRT', 'STR', 'TRS', 'TSR'].map((x) => ({
    value: x,
    label: x,
}))
